import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * Wordmark tipográfica da marca. inverted = branco + ouro (header ink).
 */
export default function Wordmark({ inverted = false, to = '/', fontSize }) {
    return (
        <Box
            component={to ? Link : 'span'}
            to={to || undefined}
            aria-label="Inovart Gold"
            sx={{
                ...styles.wordmark,
                color: inverted ? 'common.white' : 'primary.main',
                fontSize: fontSize || { xs: '1.15rem', md: '1.35rem' },
                '&:hover': {
                    color: inverted ? 'common.white' : 'primary.main',
                },
                '&:hover .gold': {
                    color: 'secondary.dark',
                },
            }}
        >
            INOVART
            <Box component="span" className="gold" sx={styles.gold}>
                GOLD
            </Box>
        </Box>
    );
}

const styles = {
    wordmark: {
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: { xs: 0.6, md: 0.85 },
        fontFamily: 'DM Serif Display',
        fontWeight: 400,
        letterSpacing: '0.04em',
        lineHeight: 1,
        textDecoration: 'none',
        whiteSpace: 'nowrap',
    },
    gold: {
        color: 'secondary.main',
        letterSpacing: '0.06em',
    },
};
